var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlotsInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b7312c;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.61,30.3v30.9c0,2,1.7,3.7,3.7,3.7h47c2,0,3.7-1.7,3.7-3.7v-30.9c0-2-1.7-3.7-3.7-3.7H15.31c-2,0-3.7,1.6-3.7,3.7M63.51,30.3v30.9c0,.7-.6,1.2-1.2,1.2H15.31c-.7,0-1.2-.6-1.2-1.2v-30.9c0-.7.6-1.2,1.2-1.2h47c.7,0,1.2.5,1.2,1.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.41,41.4v8.7c0,2,1.7,3.7,3.7,3.7v-2.5c-.7,0-1.2-.6-1.2-1.2v-8.7c0-.7.6-1.2,1.2-1.2v-2.5c-2,0-3.7,1.7-3.7,3.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.71,40.6v2.4h4.8c-1.8,2.3-2.1,3.8-2.1,7.9h2.5c0-4.5.2-5,3.3-8.3l-.9-2.1h-7.6v.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.11,40.6v2.4h4.8c-1.8,2.3-2.1,3.8-2.2,7.9h2.5c0-4.5.2-5,3.3-8.3l-.9-2.1h-7.5v.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.41,40.6v2.4h4.8c-1.8,2.3-2.1,3.8-2.2,7.9h2.5c0-4.5.2-5,3.3-8.3l-.9-2.1h-7.5v.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.91,30.3h2.5v30.9h-2.5v-30.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.21,30.3h2.5v30.9h-2.5v-30.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.71,15.1c-2.7,0-4.8,2.2-4.8,4.8,0,2.2,1.5,4.1,3.6,4.7v15.6c.7,0,1.2.6,1.2,1.2v8.6c0,.7-.6,1.2-1.2,1.2v2.5c2,0,3.7-1.7,3.7-3.7v-8.7c0-1.1-.4-2.1-1.2-2.8v-13.9c2.6-.7,4.1-3.3,3.4-5.9-.6-2.1-2.5-3.6-4.7-3.6M69.71,22.3c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4,2.4,1.1,2.4,2.4h0c0,1.3-1.1,2.4-2.4,2.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotsInactive);
export default __webpack_public_path__ + "static/media/Slots-inactive.698dbd271254adfa92b7a00658b9a7c0.svg";
export { ForwardRef as ReactComponent };